module.exports = __webpack_public_path__ + "img/searcher.b4b1434c.svg";